// Version : 1.0.0
// Author : AGALYA

import { takeLatest, put, all, call } from 'redux-saga/effects';
import NocPhotosActionType from './noc-photos.types';
import {
	updateNocPhotosSuccess,
	updateNocPhotosFailure,
	updateNocPhotosResponseChanged,
} from './noc-photos.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import { nocPhotosUpdate } from './noc-photos.service';

/** ***************** update Noc Photos Start ************************/
export function* updateNocPhotosId({ payload }: any) {
	try {
		const key = 'updateNocPhotosID';
		const {
			companyID,
			databaseName,
			memberID,
			memberNocImage1,
			memberNocImage2,
			memberNocImage3,
			memberNocDetails1,
			memberNocDetails2,
			memberNocDetails3,
			userID,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberID,
			MemberNocImg1: memberNocImage1,
			MemberNocImg2: memberNocImage2,
			MemberNocImg3: memberNocImage3,
			MemberNocDetails1: memberNocDetails1,
			MemberNocDetails2: memberNocDetails2,
			MemberNocDetails3: memberNocDetails3,
			OfficerID: userID,
		};

		const nocPhotosData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(nocPhotosUpdate, nocPhotosData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateNocPhotosFailure(responseData.data));
		} else {
			yield put(updateNocPhotosSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateNocPhotosFailure(error));
	}
}

export function* updateNocPhotosResponseClear() {
	yield put(updateNocPhotosResponseChanged());
}

export function* onNocPhotosUpdateStart() {
	yield takeLatest(NocPhotosActionType.UPDATE_NOC_PHOTOS_START, updateNocPhotosId);
}

export function* onNocPhotosUpdateResponseRest() {
	yield takeLatest(
		NocPhotosActionType.UPDATE_NOC_PHOTOS_RESPONSE_REST_START,
		updateNocPhotosResponseClear,
	);
}
/** ***************** update Noc Photos End ************************/

export function* nocPhotosSaga() {
	yield all([call(onNocPhotosUpdateStart), call(onNocPhotosUpdateResponseRest)]);
}
